module.exports = __webpack_public_path__ + "img/calc.5c03691.png";